import React, {Fragment} from 'react';
import {Checkbox, Grid, Icon, Label} from 'semantic-ui-react';
import catchErrors from 'hoc/catchErrors';
import 'react-tippy/dist/tippy.css';
import {Tooltip} from 'react-tippy';


import {makeDBContentImageUrl, isFunction} from '../../../utils/DBUtils';

{/* We need a custom component to show the 2 images in a spot the difference
  level and let the user click to pick the differences */}
class SpotTheDifferencePicker extends React.Component {

    render() {
      if ( !this.props.originalImageId || !this.props.differencesImageId) {
        return null;
      }

        return (
          <Fragment>
            <Label basic className="db-field-label">
              <i className="asterisk icon inline"></i>Identify Differences
                {this.props.helpContent ?
                    <Grid.Column width={1} verticalAlign="middle" className="db-tooltip">
                        <div className="popup-scroll-container">
                            <Tooltip
                                // options
                                html={(
                                    <div style={{'maxWidth': '600px', 'maxHeight': '600px', 'overflow': 'auto'}}>
                                      {isFunction(this.props.helpContent) ? this.props.helpContent(this.props.formProxy) : this.props.helpContent}
                                    </div>
                                )}
                                arrow="true"
                                position="right-top"
                                theme="light"
                                trigger="click"
                                style={{width: '40%'}}
                            >
                                <Icon color="blue" name="info circle"/>
                            </Tooltip>
                        </div>

                    </Grid.Column>
                    : ""
                }
            </Label>
            <div  className="std-difference-picker">
              <div onClick={(event) => this.props.addDifference(event)} id="target-image" className="target-image">
                { this.props.differences ? this.props.differences.map((difference, i) => {
                  if (!difference.deleted) {
                    let style = {
                      top : (((difference.top) / 200) * 100) + '%',
                      left: (((difference.left) / 300) * 100) + '%'
                    };
                    return(
                        <div  className="difference"  style={style}>
                          <Icon name="check"></Icon>
                          <span className="difference-number">{i+1}</span>
                        </div>
                    )
                  }
                  else {
                    return ("");
                  }
                }

                ) : "" }
                <img className="image-difference" src={makeDBContentImageUrl(this.props.originalImageId)}/>
              </div>
              <div onClick={(event) => this.props.addDifference(event)} id="target-image-2" className="target-image">
                { this.props.differences ? this.props.differences.map((difference, i) => {
                  if (!difference.deleted) {
                    let style = {
                      top : (((difference.top) / 200) * 100) + '%',
                      left: (((difference.left) / 300) * 100) + '%'
                    };
                    return(
                        <div className="difference"  style={style}>
                          <Icon name="check"></Icon>
                          <span className="difference-number">{i+1}</span>
                        </div>
                    )
                  }


                }) : "" }
                <img className="image-difference" src={makeDBContentImageUrl(this.props.differencesImageId)}/>
              </div>
            </div>
            <div  className="differences-bar">
              {this.props.differences ? this.props.differences.map((difference, i) => {
                if (!difference.deleted) {
                  return(
                    <span>{i+1}<Icon name="close"  onClick={() => this.props.removeDifference(difference,i)}></Icon></span>
                  );
                }

              }) : "" }
            </div>
          </Fragment>
        );
    }
}

SpotTheDifferencePicker.propTypes = {

};

export default catchErrors(SpotTheDifferencePicker);



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/SpotTheDifferencePicker.jsx